import { render, staticRenderFns } from "./Arrival.vue?vue&type=template&id=edad150c&scoped=true"
import script from "./Arrival.vue?vue&type=script&lang=js"
export * from "./Arrival.vue?vue&type=script&lang=js"
import style0 from "./Arrival.vue?vue&type=style&index=0&id=edad150c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edad150c",
  null
  
)

export default component.exports